module.exports = __webpack_public_path__ + "Pacchero-5Ru.jpg";